import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import locales from '../../../content.json';

import bg_webp from './img/bg.webp';
import bg_jpg from './img/bg.jpg';
import bg3_webp from './img/bg3.avif';
import bg3_jpg from './img/bg3.jpg';

import bg_webp_dark from './img/bgDark.webp';
import bg_jpg_dark from './img/bgDark.jpg';

import { analyticsEventsTracker, GTMOnboardingFunnelEvent, EVENT_TRACKERS } from '../../../utils/analytics';
import s from './index.module.scss';
import { getParameterFromURL } from '../../../utils/scripts';
import { assignPDFHighPricesGroup } from '../../../utils/scripts/pdfHighPricesTest';

export const MainScreen = () => {
  const lastDogTraining = useSelector(state => state.data.lastDogTraining);
  const subscrUK = getParameterFromURL('subscrUK');
  const customV52 = getParameterFromURL('config') === 'customV52';
  const version = subscrUK ? 'version2UK' : 'version2';

  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const v50p20 = getParameterFromURL('config') === 'customV50' && getParameterFromURL('tariff') === 'v41';
  const v49p30 = getParameterFromURL('config') === 'customV49' && getParameterFromURL('tariff') === 'v48';

  const lastDogTrainingPaywall = lastDogTraining || v50p20 || v49p30;

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.showPaywall(version), EVENT_TRACKERS.GTM);
    assignPDFHighPricesGroup();
  }, []);

  return (
    <div className={s.mainScreen}>
      {customV52 ? (
        <picture>
          <source srcSet={bg3_webp} type="image/avif" />
          <img src={bg3_jpg} alt="header image" />
        </picture>
      ) : (
        <picture>
          <source srcSet={darkTheme ? bg_webp_dark : bg_webp} type="image/webp" />
          <img src={darkTheme ? bg_jpg_dark : bg_jpg} alt="header image" />
        </picture>
      )}
      {lastDogTrainingPaywall ? (
        <h2 className={s.title}>{locales[window.userLang].payment_text_228}</h2>
      ) : (
        <>
           <h2 className={s.title}>{locales[window.userLang].payment_text_1}</h2>
          <p
            className={s.subtitle}
            dangerouslySetInnerHTML={{
              __html: locales[window.userLang].payment_text_2,
            }}
          />
        </>
      )}
      
    </div>
  );
};
